import { isBookableExperience } from './restoreCart'

import {
  LETripItem,
  SavedCruiseData,
  SavedExperienceData,
  SavedHotelData,
  SavedTourData,
} from 'tripPlanner/types/tripItem'

const BOOK_NOW_COPY = 'Book now'

export const getRestoreCartButtonCopy = (
  item: LETripItem,
): string | undefined => {
  switch (item.type) {
    case 'CRUISE':
      return getSavedCruiseTileCopy(item.savedItemData)
    case 'EXPERIENCE':
      return getSavedExperienceTileCopy(item.savedItemData)
    case 'FLIGHT':
      return BOOK_NOW_COPY
    case 'HOTEL':
      return getSavedHotelTileCopy(item.savedItemData)
    case 'ACCOMMODATION_RENTAL':
      return getSavedAccommodationRentalTileCopy(item.savedItemData)
    case 'TOUR':
      return getSavedTourTileCopy(item.savedItemData)
  }
}

function getSavedExperienceTileCopy(savedItemData: SavedExperienceData) {
  if (isBookableExperience(savedItemData) || !!savedItemData.date) {
    return BOOK_NOW_COPY
  } else {
    return undefined
  }
}

function getSavedCruiseTileCopy(savedItemData: SavedCruiseData) {
  if ('departure' in savedItemData && savedItemData.departure) {
    return BOOK_NOW_COPY
  } else if ('startDate' in savedItemData && savedItemData.startDate) {
    return BOOK_NOW_COPY
  }
  return undefined
}

function getSavedTourTileCopy(savedItemData: SavedTourData) {
  const { offerType, occupancies } = savedItemData

  if (offerType === 'tour_v2') {
    // We don't support Tour V2 deep linking yet
    return undefined
  }

  if (offerType === 'tour') {
    // We only restore cart when saved from checkout
    if (occupancies && occupancies.length > 0) {
      return BOOK_NOW_COPY
    }

    return undefined
  }
}

function getSavedHotelTileCopy(savedItemData: SavedHotelData) {
  const { roomTypeId, occupancies, checkIn, checkOut } = savedItemData

  if ((checkIn && checkOut) || roomTypeId || occupancies) {
    return BOOK_NOW_COPY
  }
  return undefined
}

function getSavedAccommodationRentalTileCopy(savedItemData: SavedHotelData) {
  const { occupancies, checkIn, checkOut } = savedItemData

  if ((checkIn && checkOut) || occupancies) {
    return BOOK_NOW_COPY
  }
  return undefined
}
